import * as actions from '../actions/solicitorHomePageInfo';
import * as ActionTypes from '../actions/index';
import xs from 'xstream';
import BASE_URL from './variables';
import {isAgent} from "../helpers/functions";

export function getHomePageInfoAfterloggingIn(sources) {
    let httpResponse$ = sources.HTTP
        .select('users')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .filter(response => isAgent(JSON.parse(response.text).roles))
        .map(response => actions.getSolicitorHomePageInfo());

    return {
        ACTION: httpResponse$
    }
}

export function requestGetSolHomePageInfo(sources) {
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.GET_SOLICITOR_HOME_PAGE_INFO)
        .map(action => ({
            url: BASE_URL + 'api/agents/landingpage/telephones',
            category: 'requestGetSolHomePageInfo',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('requestGetSolHomePageInfo')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.receiveSolicitorHomePageInfo(JSON.parse(response.text)));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function receiveFailedResponseSolicitorHomePageInfo(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestGetSolHomePageInfo')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.failedToGetSolicitorHomePageInfo(response));

    return {
        ACTION: httpResponse$
    };
}